'use strict';

function isArrayIndex(n) {
  return n >>> 0 == n && n != 0xFFFFFFFF;
}

module.exports = isArrayIndex;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/isArrayIndex.js
// module id = 259
// module chunks = 0